import { render } from "./product-recommendations.vue?vue&type=template&id=4a0a4948"
import script from "./product-recommendations.vue?vue&type=script&lang=js"
export * from "./product-recommendations.vue?vue&type=script&lang=js"

import "./product-recommendations.vue?vue&type=style&index=0&id=4a0a4948&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__